module.exports = __webpack_public_path__ + "img/depmap_svg_V37.8618ad99.svg";